import Spinners from "components/Shared/Spinners"
import Switch2 from "components/Shared/Switch2"
import React from "react"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import {
  Badge,
  BreadcrumbItem,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap"
import { getItemsDetails } from "store/actions/itemsAction"
import Breadcrumbs from "components/Common/Breadcrumb"
import placeholderImage from "assets/images/placeholderImage.png"
import BackButton from "components/Shared/BackButton"
import { useTranslation } from "react-i18next"

const ItemDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Item Details | Sign Burger")

  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const { itemId } = useParams()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { loading, itemDetails } = useSelector(state => state.Items)

  useEffect(() => {
    getOldValues()
  }, [])

  const getOldValues = () => {
    const payload = {
      id,
    }
    dispatch(getItemsDetails(payload))
  }

  if (loading) return <Spinners />

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs />
          <Row>
            <Col lg={8}>
              <Card>
                <CardBody>
                  <Row>
                    <div>
                      <CardTitle className="mb-2 d-flex align-items-center">
                        <BackButton /> {t("Item Details")}
                      </CardTitle>
                      <Table className="table mb-0 table-bordered">
                        <tbody>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Id")}
                            </th>
                            <td>{itemDetails._id}</td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Name(English)")}
                            </th>
                            <td>{itemDetails.name || "-"}</td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Name(عربي)")}
                            </th>
                            <td>{itemDetails.nameAr || "-"}</td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Status")}
                            </th>
                            <td>
                              {itemDetails?.status === 1 ? (
                                <Badge className="bg-success">
                                  {t("Active")}
                                </Badge>
                              ) : (
                                <Badge className="bg-danger">
                                  {t("Deactive")}
                                </Badge>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("SKU")}
                            </th>
                            <td>{itemDetails.SKU}</td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Slug")}
                            </th>
                            <td>{itemDetails.slug || "-"}</td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Description(English)")}
                            </th>
                            <td>{itemDetails.description || "-"}</td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Description(عربي)")}
                            </th>
                            <td>{itemDetails.descriptionAr || "-"}</td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Display Order")}
                            </th>
                            <td>{itemDetails.displayOrder}</td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Price")}
                            </th>
                            <td>
                              {itemDetails.price || "-"}{" "}
                              {itemDetails.countryCode === "SA" ? "SAR" : "RS"}
                            </td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Original Price")}
                            </th>
                            <td>
                              {itemDetails.originalPrice || "-"}{" "}
                              {itemDetails.countryCode === "SA" ? "SAR" : "RS"}
                            </td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Image Type")}
                            </th>
                            <td>{itemDetails.imageUrlType || "-"}</td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Calories")}
                            </th>
                            <td>{itemDetails.calories || "-"}</td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Calorie Count")}
                            </th>
                            <td>{itemDetails.calorieCount || "-"}</td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Person Count PerServing")}
                            </th>
                            <td>{itemDetails.personCountPerServing || "-"}</td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Disable For Pickup")}
                            </th>
                            <td>
                              <Switch2
                                id={"pickupEnabled"}
                                isChecked={itemDetails.disableForPickup}
                                isReadOnly={true}
                              />
                            </td>
                          </tr>
                          {/* <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              Disable For Delivery
                            </th>
                            <td>
                              <Switch2
                                id={"pickupEnabled"}
                                isChecked={itemDetails.disableForDelivery}
                                isReadOnly={true}
                              />
                            </td>
                          </tr> */}
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Is Discount Allowed")}
                            </th>
                            <td>
                              <Switch2
                                id={"pickupEnabled"}
                                isChecked={itemDetails.isDiscountAllowed}
                                isReadOnly={true}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Is Combo")}
                            </th>
                            <td>
                              <Switch2
                                id={"pickupEnabled"}
                                isChecked={itemDetails.isCombo}
                                isReadOnly={true}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Is Featured")}
                            </th>
                            <td>
                              <Switch2
                                id={"pickupEnabled"}
                                isChecked={itemDetails.isFeatured}
                                isReadOnly={true}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Is Customizable")}
                            </th>
                            <td>
                              <Switch2
                                id={"pickupEnabled"}
                                isChecked={itemDetails.isCustomizable}
                                isReadOnly={true}
                              />
                            </td>
                          </tr>
                          {/* <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              Category Id
                            </th>
                            <td>{itemDetails?.categoryId?._id || "-"}</td>
                          </tr> */}
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Category Name")}
                            </th>
                            <td>
                              {language === "sa"
                                ? itemDetails?.categoryId?.nameAr
                                : itemDetails?.categoryId?.name || "-"}
                            </td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Out Of Stocks Branches Names")}
                            </th>
                            <td>
                              {itemDetails?.outOfStockForBranches?.length > 0
                                ? itemDetails?.outOfStockForBranches
                                    ?.map(item =>
                                      language === "sa"
                                        ? item.nameAr
                                        : item.name
                                    )
                                    ?.join(", ")
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Disabled Branches Names")}
                            </th>
                            <td>
                              {itemDetails?.disabledBranches?.length > 0
                                ? itemDetails?.disabledBranches
                                    ?.map(item =>
                                      language === "sa"
                                        ? item.nameAr
                                        : item.name
                                    )
                                    ?.join(", ")
                                : "-"}
                            </td>
                          </tr>

                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Announcement(English)")}
                            </th>
                            <td>{itemDetails.announcementEn || "-"}</td>
                          </tr>
                          <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              {t("Announcement(عربي)")}
                            </th>
                            <td>{itemDetails.announcementAr || "-"}</td>
                          </tr>

                          {/* <tr>
                            <th
                              scope="row"
                              style={{ width: "400px" }}
                              className={"text-capitalize"}
                            >
                              Category Status
                            </th>
                            <td>
                              {itemDetails?.categoryId?.status === 1 ? (
                                <Badge className="bg-success">Active</Badge>
                              ) : (
                                <Badge className="bg-danger">Deactive</Badge>
                              )}
                            </td>
                          </tr> */}
                        </tbody>
                      </Table>
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4}>
              <Card className="">
                <CardBody>
                  <img
                    src={
                      itemDetails.imageUrl
                        ? itemDetails.imageUrl
                        : placeholderImage
                    }
                    alt=""
                    className="img-fluid d-block mx-auto"
                    style={{ height: "100%", objectFit: "contain" }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ItemDetails
